import { Dispatch } from 'redux';
import { handleError } from './dashboard';
import api from '../services/api';

export const ChargeActions = {
  SHOW_ADD_CHARGE_DIALOG: 'SHOW_ADD_CHARGE_DIALOG',
};

export const setShowAddChargeDialog =
  (toShow: boolean, selectedTenant?: string) => (dispatch: Dispatch) => {
    dispatch({
      type: ChargeActions.SHOW_ADD_CHARGE_DIALOG,
      payload: { show: toShow, selectedTenant },
      meta: {
        track: true,
      },
    });
  };
type AddChargeData = {
  tenant_code: string;
  charge_code: string;
  property_code: string;
  rent: number;
};
export const addCharge =
  (addChargeData: AddChargeData) => (dispatch: Dispatch) => {
    return api
      .addCharge(addChargeData)
      .then((res) => {
        dispatch({
          type: 'ADD_OTHER_CHARGES',
          payload: res.data.charge,
          meta: {
            track: true,
            includeData: true,
          },
        });
        // dispatch({
        //     type: 'SHOW_NOTIFICATIONS',
        //     payload: { message: ` Charge added`, type: 'success' }
        // })
      })
      .catch((err) => {
        handleError(err, dispatch);
        console.log(err);
      });
  };
export const removeCharge =
  (chargeId: any, Tenant_Code: any) => (dispatch: any) => {
    return api
      .removeCharge({ chargeId })
      .then(() => {
        dispatch({
          type: 'REMOVE_CHARGE',
          payload: { chargeId, Tenant_Code },
          meta: {
            track: true,
            includeData: true,
          },
        });
        dispatch({
          type: 'SHOW_NOTIFICATIONS',
          payload: { message: ` Charge removed`, type: 'info' },
        });
      })
      .catch((err) => {
        console.log(err);
        handleError(err, dispatch);
      });
  };
export const getCharges = () => (dispatch: Dispatch) => {
  return api
    .getCharges()
    .then((res) => {
      dispatch({
        type: 'CHARGE_CODES',
        payload: res.data.data,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      handleError(err, dispatch);
      console.log(err);
    });
};
export const updateCharge = (data: any) => (dispatch: Dispatch) => {
  return api
    .updateCharge(data)
    .then(() => {
      dispatch({
        type: 'UPDATE_CHARGE',
        payload: data,
        meta: {
          track: true,
          includeData: true,
        },
      });
      dispatch({
        type: 'SHOW_NOTIFICATIONS',
        payload: { message: 'Charge Updated', type: 'success' },
      });
      //dispatch notification of update
    })
    .catch((err) => {
      handleError(err, dispatch);
      console.log(err);
    });
};

export const updateChargeToMarketRent = () => () => {
  console.log('updateChargeToMarketRent');
  // dispatch({
  //     type: 'IS_LOADING',
  //     payload: true
  // })
  // api.removeOffer({id,marketRent}).then(res => {
  //     dispatch({
  //         type: 'UPDATE_CHARGE_TO_MARKET_RENT',
  //         payload: { id, tenant_code,charge:res.data }
  //     })
  // }).finally(() => {
  //     dispatch({
  //         type: 'IS_LOADING',
  //         payload: false
  //     })
  // })
};
